module.exports = __webpack_public_path__ + "static/media/poster-342.bc9c46b4.png";